import React, { useState, useEffect, useContext } from "react";
import "../styles/SideBar.css";
import welcomeIcon from "../assets/HomeIcon.png";
import manageIcon from "../assets/subscription.png";
import animeIcon from "../assets/animeIcon.png";
import RAGIcon from "../assets/RAG.png";
import photoToAnimeIcon from "../assets/photoToAnimeIcon.png";
import lineImage from "../assets/Line3.png";
import SettingIcon from "../assets/SettingIcon.png";
import ProfileIcon from "../assets/profileicon.png";
import ChatHeader from "./ChatHeader";
import ImageGeneration from "./ImageGeneration";
import Result from "./Result";
import TextGeneration from "./TextGeneration";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import Playground from "./Playground";
import Header from "./Header";
import ChatBot from "./ChatBot";
import Chat from "./Chat";
import { GenerationContext } from "../context/GenerationContext";
import ProfileDetails from "./ProfileDetails";

const NewGeneration = () => {
  const [imageValue, setImage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const { selected, setSelected } = useContext(GenerationContext);
  const { prompt = "" } = location.state || {};
  const [userProfilePhoto, setUserProfilePhoto] = useState(ProfileIcon);

  useEffect(() => {
    if (location.state?.selection) {
      setSelected("chatbot");
    }
  });

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserProfilePhoto(user.photoURL);
        setUserEmail(user.email);
        setUserName(user.displayName);
        console.log(user);
      } else {
        console.log("No user logged in");
      }
    });

    return () => unsubscribe();
  }, [selected]);

  const chatbotpage = () => {
    setSelected("chatbot");
  };

  const welcomepage = () => {
    setSelected("welcome");
  };

  const goToNewPage = () => {
    setSelected("manage", { state: { tab: "Plans And Billing" } });
  };

  const setting = () => {
    setSelected("settings", { state: { tab: "Profile Details" } });
  };

  const upgrade = () => {
    setSelected("upgrade", { state: { tab: "Plans And Billing" } });
  };

  const goToNewPage1 = () => {
    setSelected("profile", { state: { tab: "Profile Details" } });
  };

  const buttonsData = [
    { text: "Text To Image", icon: animeIcon },
    { text: "Image To Image", icon: photoToAnimeIcon },
  ];

  const handleGeneration = (imageValue) => {
    setImage(imageValue);
  };

  let truncatedUserName = "";
  let truncatedUserEmail = "";

  if (userName) {
    truncatedUserName =
      userName.length > 8 ? `${userName.substring(0, 8)}...` : userName;
    truncatedUserEmail =
      userEmail.length > 17 ? `${userEmail.substring(0, 17)}...` : userEmail;
  }

  return (
    <div>
      <div className="chupana">
        <ChatHeader> </ChatHeader>
      </div>
      <div className="chupana view">
        <div className="sidebar sidebar-height">
          <div className="sidebar-scrollable">
            <button
              className={`sidebar-button ${
                selected === "welcome" ? "selected" : ""
              }`}
              onClick={welcomepage}
            >
              <img
                src={welcomeIcon}
                alt="Welcome Icon"
                className="sidebar-icon1"
              />
              Welcome
            </button>
            <button
              className={`sidebar-button ${
                selected === "manage" ? "selected" : ""
              }`}
              onClick={goToNewPage}
            >
              <img
                src={manageIcon}
                alt="Manage Icon"
                className="sidebar-icon1"
              />
              Manage Subscription
            </button>

            <img src={lineImage} alt="Divider" className="divider" />

            {buttonsData.map((button, index) => (
              <button
                key={index}
                className={`sidebar-button ${
                  selected === button.text ? "selected" : ""
                }`}
                onClick={() => setSelected(button.text)}
              >
                <img
                  src={button.icon}
                  alt={`${button.text} Icon`}
                  className="sidebar-icon"
                />
                {button.text}
              </button>
            ))}
            <button
              className={`sidebar-button ${
                selected === "chatbot" ? "selected" : ""
              }`}
              onClick={chatbotpage}
            >
              <img src={RAGIcon} alt="Chatbot Icon" className="sidebar-icon" />
              Chatbot
            </button>

            <img src={lineImage} alt="Divider" className="divider" />

            <button
              className={`sidebar-button ${
                selected === "settings" ? "selected" : ""
              }`}
              onClick={setting}
            >
              <img
                src={SettingIcon}
                alt="Settings Icon"
                className="sidebar-icon12"
              />
              Settings
            </button>
          </div>
          <div className="footer">
            <div>
              <div className="userbox-adjustment">
                <button className="profile-adjustment" onClick={goToNewPage1}>
                  <div className="user-box">
                    {userProfilePhoto && (
                      <img
                        src={userProfilePhoto}
                        alt="User Icon"
                        className="user-icon1"
                        style={{ borderRadius: "30px" }}
                      />
                    )}
                    <div className="user-info">
                      <div className="user-name">
                        {truncatedUserName}
                        {/* <button className="free-button">Free</button> */}
                      </div>
                      <div className="user-email">{truncatedUserEmail}</div>
                    </div>
                  </div>
                </button>
                <button className="upgrade-to-pro-button" onClick={upgrade}>
                  Upgrade to Pro
                </button>
              </div>
            </div>

            <div style={{ fontSize: 12.5 }}>
              katanaInuAIgenerate@{" "}
              <span className="footer-highlight">
                2024, All Rights Reserved.
              </span>
            </div>
          </div>
        </div>
        <div
          className="main-cc"
          style={{
            width: "100%",
            height: "100%",
            overflowY: "auto",
          }}
        >
          {selected === "Text To Image" || selected === "" ? (
            <>
              <TextGeneration
                onImageGenerated={handleGeneration}
                className="text-generator"
                prompt={prompt}
              />
              <Result
                generatedImage={imageValue}
                className="ProcessAdjustment"
              />
            </>
          ) : selected === "Image To Image" ? (
            <>
              <ImageGeneration />
              <Result
                generatedImage={imageValue}
                className="ProcessAdjustment"
              />
            </>
          ) : null}
          {selected === "welcome" ? (
            <div className="chatbot-container">
              <ChatBot />
            </div>
          ) : null}
          {selected === "chatbot" ? (
            <div className="chatbot-container">
              <Chat />
            </div>
          ) : null}
          {selected === "manage" ? (
            <div className="chatbot-container">
              <ProfileDetails tabs={"Plans And Billing"} />
            </div>
          ) : null}
          {selected === "upgrade" ? (
            <div className="chatbot-container">
              <ProfileDetails tabs={"Plans And Billing"} />
            </div>
          ) : null}
          {selected === "settings" ? (
            <div className="chatbot-container">
              <ProfileDetails tabs={"Profile Details"} />
            </div>
          ) : null}
          {selected === "profile" ? (
            <div className="chatbot-container">
              <ProfileDetails tabs={"Profile Details"} />
            </div>
          ) : null}
        </div>
      </div>
      <div className="hidden">
        <Playground></Playground>
      </div>
      <div className="hidden">
        <Header></Header>
      </div>
    </div>
  );
};

export default NewGeneration;
